export default __webpack_public_path__ + "static/section_6_button_1-3f614e3cedb0b056b6dd3586a6160ac1.jpg";